module.exports = __webpack_public_path__ + "static/media/showcase-img6.c1e08426.jpg";